module.exports = __webpack_public_path__ + "img/google.614bc791.svg";